<div class="ui-project__header d-flex justify-content-between align-items-center flex-wrap">
  <div class="projects-header">
    <h3 class="mb-0">{{ 'Projects.PreviewTabs.' + taskTypeName | translate }}</h3>
    <div class="projects-header__inside">
      <app-button
        class="mr-2 my-1 my-lg-0"
        (onClick)="createNewTaskGroup()"
        [permission]="{ group: PermissionsGroups.PROJECTS, action: 'EDIT' }"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          text: ('Projects.newGroup' | translate),
          prependSrc: './assets/img/ic-plus.svg'
        }"
      />

      <list-search />

      <list-filters-btn-v2 class="ml-auto" [filters]="ProjectTasksFiltersComponent" />
    </div>
  </div>
</div>

<div class="project-tasks">
  <div class="project-tasks__content">
    <div class="project-tasks__content__tasks">
      <list-tasks
        #listTasksComponent
        [config]="config"
        [filters]="ProjectTasksFiltersComponent"
        [project]="projectPreviewService?.project"
        [projectId]="projectPreviewService.project.id"
      />
    </div>
  </div>
</div>
